module.exports = __webpack_public_path__ + "img/nav-37.d36e6a10.png";